// ─── Cortex Agent Chatbot Action Types & Creators ────────────────────────────

export const CHATBOT_TYPES = {
  // Cortex Agent messages
  CORTEX_ADD_MESSAGE: "CHATBOT_CORTEX_ADD_MESSAGE",
  CORTEX_CLEAR_HISTORY: "CHATBOT_CORTEX_CLEAR_HISTORY",

  // Modal control
  OPEN_CORTEX_MODAL: "CHATBOT_OPEN_CORTEX_MODAL",
  CLOSE_CORTEX_MODAL: "CHATBOT_CLOSE_CORTEX_MODAL",
  OPEN_CORTEX_MODAL_WITH_PROMPT: "CHATBOT_OPEN_CORTEX_MODAL_WITH_PROMPT",
  CLEAR_PENDING_PROMPT: "CHATBOT_CLEAR_PENDING_PROMPT",

  // Stream notifications
  STREAM_NOTIFICATION_SET: "CHATBOT_STREAM_NOTIFICATION_SET",
  STREAM_NOTIFICATION_CLEAR: "CHATBOT_STREAM_NOTIFICATION_CLEAR",

  // Streaming state
  CORTEX_START_STREAMING: "CHATBOT_CORTEX_START_STREAMING",
  CORTEX_STOP_STREAMING: "CHATBOT_CORTEX_STOP_STREAMING",

  // NLU feature flag
  SET_NLU_ENABLED: "CHATBOT_SET_NLU_ENABLED",
};

// ─── Action Creators ─────────────────────────────────────────────────────────

export const addCortexMessage = (message) => ({
  type: CHATBOT_TYPES.CORTEX_ADD_MESSAGE,
  payload: message,
});

export const clearCortexHistory = () => ({
  type: CHATBOT_TYPES.CORTEX_CLEAR_HISTORY,
});

export const openCortexModal = () => ({
  type: CHATBOT_TYPES.OPEN_CORTEX_MODAL,
});

export const closeCortexModal = () => ({
  type: CHATBOT_TYPES.CLOSE_CORTEX_MODAL,
});

export const openCortexModalWithPrompt = (text) => ({
  type: CHATBOT_TYPES.OPEN_CORTEX_MODAL_WITH_PROMPT,
  payload: text,
});

export const clearPendingPrompt = () => ({
  type: CHATBOT_TYPES.CLEAR_PENDING_PROMPT,
});

export const setStreamNotification = () => ({
  type: CHATBOT_TYPES.STREAM_NOTIFICATION_SET,
  payload: { timestamp: new Date().toISOString() },
});

export const clearStreamNotification = () => ({
  type: CHATBOT_TYPES.STREAM_NOTIFICATION_CLEAR,
});

export const startCortexStreaming = () => ({
  type: CHATBOT_TYPES.CORTEX_START_STREAMING,
});

export const stopCortexStreaming = () => ({
  type: CHATBOT_TYPES.CORTEX_STOP_STREAMING,
});

export const setNluEnabled = (isEnabled) => ({
  type: CHATBOT_TYPES.SET_NLU_ENABLED,
  payload: isEnabled,
});
